import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

// Closed set of adviser-driven lifecycle transitions. `issue` happens at
// creation; these map 1:1 to the AASM events the backend whitelists in
// Tracking::UpdateStatus::ALLOWED_EVENTS.
export type LoaTrackingEvent =
  | 'chase'
  | 'record_response'
  | 'require_further_information'
  | 'close';

export interface ClientCaseFactFindLetterOfAuthorityTrackingLoaRequestPutOptions {
  event: LoaTrackingEvent;
}

export type ClientCaseFactFindLetterOfAuthorityTrackingLoaRequestPutResponse =
  JsonApiResponseSingle;

export function clientCaseFactFindLetterOfAuthorityTrackingLoaRequestApi(path: string) {
  return {
    path,
    PUT: ({ event }: ClientCaseFactFindLetterOfAuthorityTrackingLoaRequestPutOptions) =>
      api.put<ClientCaseFactFindLetterOfAuthorityTrackingLoaRequestPutResponse>(path, {
        data: {
          attributes: {
            event,
          },
        },
      }),
  };
}
